// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ef957545","885":"520e37ce"}[chunkId] + ".chunk.js";
};